module.exports = __webpack_public_path__ + "img/ИФ-1(А)-031.eccb73ca.png";